import { TrackingProductModel } from "@/services/tracking/types/trackingProduct.model";

export const $WishlistModalModuleName = "wishlistModal";

export interface TWishlistModalState {
    visible: boolean;
    product?: TrackingProductModel;
}
